import { Grid } from '@mui/material'

import { AppBox, AppImage, AppTypography } from 'components'
import { appRoutes } from 'globals/constants'
import { useNavigate } from 'react-router-dom'
import { LoginForm } from './login-form/LoginForm'
import { Helmet } from 'react-helmet-async'

export const Login = () => {
  const navigate = useNavigate()
  const handleSignUpClick = () => {
    window.open('https://www.parksites.io/articles/parksitesio-is-going-private')
  }
  return (
    <>
      <Helmet>
        <title>Sign in to your ParkSitesIO account</title>
        <meta
          name="description"
          content="Sign in to your ParkSitesIO account to manage your mobile home park sheets."
        />
        <meta name="robots" content="index, follow" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'WebPage',
            headline: 'Sign into your ParkSitesIO account',
            url: 'https://app.parksites.io/login',
            image:
              'https://cdn.prod.website-files.com/65b7c6a8abe85fd988ba381c/67e2abad8795bc7e346a8913_ParkSitesIO-Sign-In--min.png',
            description: 'Sign into your ParkSitesIO account and start curing your mobile home park sheets today.',
            publisher: {
              '@type': 'Organization',
              name: 'ParkSitesIO, LLC',
              url: 'https://www.parksites.io',
              sameAs: [
                'https://www.facebook.com/parksitesio',
                'https://www.linkedin.com/company/parksitesio',
                'https://www.youtube.com/@ParkSitesIO',
              ],
              logo: 'https://cdn.prod.website-files.com/65b7c6a8abe85fd988ba381c/65c91efbb980349c04d0aa23_ParkSitesIO-logo-black-.png',
              email: 'support@parksites.io',
            },
          })}
        </script>
      </Helmet>
      <Grid container height={'100vh'} sx={{ backgroundColor: 'grey.50' }}>
        <Grid item xs={12} md={7} paddingLeft={4} paddingY={2}>
          <AppImage src="/images/logo/logo-black.png" alt="nature" height={40} />
          <Grid container justifyContent={'center'} alignItems={'center'} paddingTop={5}>
            <Grid item xs={8}>
              <AppBox display={'flex'} gap={1} flexDirection={'column'}>
                <AppTypography fontSize={40} fontWeight={700} color={'grey.900'}>
                  Sign in to your ParkSitesIO account
                </AppTypography>
                <AppTypography fontSize={16}>
                  Don’t have an account yet?
                  <AppTypography
                    component={'a'}
                    isColorPrimary
                    fontSize={16}
                    onClick={() => handleSignUpClick()}
                    paddingX={0.5}
                  >
                    Sign up
                  </AppTypography>
                  for our 7-day free trial.{' '}
                </AppTypography>
                <AppBox>
                  <LoginForm />
                </AppBox>
              </AppBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={5} maxHeight={'100vh'} overflow={'hidden'}>
          <AppBox
            height={'100%'}
            width={'100%'}
            style={{
              backgroundImage: `url('/images/loginPage/parksitesio-mobile-home-park-login-img-min.jpeg')`,
              backgroundSize: 'cover', // Cover the entire area of the box
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          ></AppBox>
        </Grid>
      </Grid>
    </>
  )
}
